import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import "./BrandsPage.css";
import Loader from "../layouts/components/Loader";

const API_BASE = "https://api.mariamlyluxe.com/public";

export default function BrandsPage() {
  const [brands, setBrands] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [totalBrands, setTotalBrands] = useState(0);
  const [bannerImage, setBannerImage] = useState(null);

  const brandsPerPage = 12;

  useEffect(() => {
    loadBrands();
    loadBannerImage();
  }, [currentPage]);

  const loadBrands = async () => {
    setLoading(true);
    setError("");
    try {
      const params = new URLSearchParams();
      params.append("page", currentPage);
      params.append("per_page", brandsPerPage);

      const response = await fetch(`${API_BASE}/api/brands?${params.toString()}`, { 
        headers: { Accept: "application/json" } 
      });
      
      if (!response.ok) throw new Error(`Failed: ${response.status}`);
      
      const data = await response.json();
      console.log('Brands API Response:', data); // Debug log
      
      const list = Array.isArray(data?.brands) ? data.brands : Array.isArray(data?.data) ? data.data : [];
      console.log('Brands list:', list); // Debug log
      
      // Filter active brands only, then sort by sort_order, then by id
      const activeBrands = list.filter(brand => brand.is_active === true);
      const sortedBrands = activeBrands.sort((a, b) => {
        const aOrder = parseInt(a.sort_order) || 0;
        const bOrder = parseInt(b.sort_order) || 0;
        if (aOrder !== bOrder) {
          return aOrder - bOrder;
        }
        return a.id - b.id;
      });
      
      setBrands(sortedBrands);
      setTotalPages(data?.last_page || data?.total_pages || 1);
      setTotalBrands(data?.total || list.length || 0);
    } catch (e) {
      setError("Failed to load brands.");
      console.warn(e);
    } finally {
      setLoading(false);
    }
  };

  const loadBannerImage = async () => {
    try {
      const response = await fetch(`${API_BASE}/api/pages-banners/brands`, {
        headers: { Accept: "application/json" }
      });
      
      if (response.ok) {
        const data = await response.json();
        if (data.success && data.banner && data.banner.image_url) {
          setBannerImage(data.banner.image_url);
        }
      }
    } catch (e) {
      console.warn("Failed to load banner image:", e);
      // Fallback to default image if API fails
      setBannerImage('../images/crosswalk.jpg');
    }
  };

  if (loading) {
    return (
      <div className="brands-loading">
        <Loader />
        <p>Loading brands…</p>
      </div>
    );
  }

  if (error) {
    return (
      <div className="brands-error">
        <p>{error}</p>
        <button onClick={loadBrands}>Try Again</button>
      </div>
    );
  }

  return (
    <section className="brands-page">
      {/* Banner Section */}
      <div 
        className="brands-banner"
        style={{
          backgroundImage: bannerImage ? `url(${bannerImage})` : 'url(../images/crosswalk.jpg)'
        }}
      >
        <div className="brands-banner-content">
          <h1 className="brands-banner-title">Brands</h1>
          <nav className="brands-breadcrumb">
            <Link to="/">Home</Link>
            <span className="brands-breadcrumb-separator">›</span>
            <span className="brands-breadcrumb-current">Brands</span>
          </nav>
        </div>
      </div>

      <div className="brands-container">
        <div className="brands-content">
          {/* Brands Grid */}
          <div className="brands-grid">
            {console.log('Rendering brands:', brands)}
            {brands.length === 0 ? (
              <div style={{ gridColumn: '1 / -1', textAlign: 'center', padding: '2rem', color: '#666' }}>
                No brands found
              </div>
            ) : (
              brands.map((brand) => (
              <Link 
                key={brand.id} 
                to={brand.slug ? `/brands/${encodeURIComponent(brand.slug)}` : `/shop?brand_id=${brand.id}`}
                className="brand-card"
              >
                <div className="brand-image">
                  {brand.image_url ? (
                    <img src={brand.image_url} alt={brand.name} />
                  ) : (
                    <div className="brand-placeholder">
                      <span>{brand.name?.[0] ?? "B"}</span>
                    </div>
                  )}
                </div>
                <div className="brand-info">
  <span className="brand-name">{brand.name || "Unknown Brand"}</span>
  <span className="brand-arrow">
    <svg xmlns="http://www.w3.org/2000/svg" 
         viewBox="0 0 24 24" 
         width="20" 
         height="20" 
         fill="currentColor">
      <path d="M12 4l1.41 1.41L8.83 10H20v2H8.83l4.58 4.59L12 18l-8-8 8-8z"/>
    </svg>
  </span>
</div>

              </Link>
              ))
            )}
          </div>

          {/* Pagination */}
          {totalPages > 1 && (
            <div className="brands-pagination">
              <button
                className="pagination-btn"
                onClick={() => setCurrentPage((v) => Math.max(1, v - 1))}
                disabled={currentPage === 1}
              >
                &lt;
              </button>
              <span className="pagination-info">
                {currentPage} of {totalPages}
              </span>
              <button
                className="pagination-btn"
                onClick={() => setCurrentPage((v) => Math.min(totalPages, v + 1))}
                disabled={currentPage === totalPages}
              >
                &gt;
              </button>
            </div>
          )}
        </div>
      </div>
    </section>
  );
}
